/** @jsxRuntime classic */
/** @jsx jsx */

import React from "react";
import Home from "./Pages/Home/Home";
import News from "./Pages/News/News";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { jsx } from "@emotion/react";
import { main } from "./mainStyle";
import Legal from "./Pages/Legal Disclaimer/Legal";
import ContactUs from "./Pages/Contact us/ContactUs";
import Services from "./Pages/Services/Services";
import Players from "./Pages/Players/Players";
import CookiesPolicy from "./Pages/Cookies Policy/CookiesPolicy";
import PlayerPage from "./Pages/Players/Player page/PlayerPage";
import Coaches from "./Pages/Coaches/Coaches";
import CoachPage from "./Pages/Coaches/Coach Page/CoachPage";
import Footer from "./Footer";
//about us 2, the new one
import AboutUs2 from "./Pages/About us/AboutUs2";
import PrivacyPolicy from "./Pages/Legal Disclaimer/PrivacyPolicy";
import Header from "./Header/Header";


const router = createBrowserRouter([
  { path: "/services", element: <Services /> },
  { path: "/news", element: <News /> },
  { path: "/about-us", element: <AboutUs2 /> },
  { path: "/legal-disclaimers", element: <Legal /> },
  { path: "/contact-us", element: <ContactUs /> },
/*   { path: "/players/:id", element: <Players /> },
 */  { path: "/players/:id", element: <PlayerPage /> } ,
  { path: "/players", element: <Players /> } ,
  { path: "/coaches/:id", element: <CoachPage /> } ,
  { path: "/coaches", element: <Coaches /> } /* no */,
  { path: "/cookies-policy", element: <CookiesPolicy /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/cookies-policy", element: <CookiesPolicy /> },
  { path: "/", element: <Home /> },
]);

function Main() {
  return (
    <div css={main}>
      <RouterProvider router={router} />
    </div>
  );
}

export default Main;
